import { css } from "styled-components";
import token from "styled-token";
import { StyledIcon } from "../../components/Icon/Icon";

var todayCSS = function todayCSS(props) {
  if (!props.today) {
    return "";
  }

  return token("Button.tertiary.borderColor", function (borderColor) {
    return borderColor && "\n                &,\n                &:focus:not([aria-pressed=\"true\"]) {\n                    border-color: " + borderColor + ";\n                }\n            ";
  })(props);
};
/** @class DatePickerButtonMixin */

/** @method */


export var DatePickerButtonMixin = function DatePickerButtonMixin(props) {
  return token({
    borderRadius: "radii.ellipse",
    size: "sizes.heights.sm"
  }, function (_ref) {
    var borderRadius = _ref.borderRadius,
        size = _ref.size;
    return css(["border-radius:", ";height:", "px;width:", "px;display:flex;align-items:center;justify-content:center;padding:0;", " &:disabled{text-decoration:line-through;}", "{margin:0;}"], borderRadius, size, size, todayCSS(props), StyledIcon);
  })(props);
};